import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import productInput from './productInput'
import sign from './sigin'
import customer from './customer'
import uploads from './uploads'
import status from './status'
import userInput from './userInput'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    hasCancel: false
  },
  modules: {
    auth,
    productInput,
    sign,
    customer,
    uploads,
    status,
    userInput
  }
})
